module.exports = __webpack_public_path__ + "static/media/mainImage.32063d5f.jpg";